import { get } from 'lodash'

import api from 'common/api'

import types from './types'

export const MY_PROSPECTS_URL = '/api/my_prospects?includeUserOrder=true'
export const USER_ORDER_URL = '/api/my_prospects/user_order'

export const fetchProspects = (options) => async (dispatch) => {
  dispatch({
    type: types.FETCH_MY_PROSPECTS_START,
  })
  return api
    .get(MY_PROSPECTS_URL)
    .then((response) => {
      if (options?.sharedInterest) {
        const prospects = get(response, 'Prospects', [])
        const updatedProspects = prospects.map((prospect) => ({
          ...prospect,
          ...(prospect.SystemState !== 'dismissed_state' && prospect.SystemState !== 'rejected_state'
            ? { StudentSharedInterest: options.sharedInterest }
            : { StudentSharedInterest: prospect.StudentSharedInterest }),
        }))
        response.Prospects = updatedProspects
      }
      dispatch({
        type: types.FETCH_MY_PROSPECTS_SUCCESS,
        payload: get(response, 'Prospects'),
        topChoices: get(response, 'UserOrder'),
      })
      return response
    })
    .catch(() => {
      dispatch({
        type: types.FETCH_MY_PROSPECTS_FAILURE,
      })
    })
}
